<template>
	<div>
    <div class="popup_high_right buy-number-popup"
         :class="['level-'+level,{}]">

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <h3 class="title" >
		            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
		            Buy +{{ number.phone_number }}
	            </h3>
<!--	            <span>* The prices are experimental and are set to be adjusted slightly in the near future.</span>-->

	            <div class="layout-column flex">

		            <div class="flex-none layout-column margin-b-20 margin-t-25">
			            <label class="margin-b-10">Name this number anything (optional)</label>
			            <div>
				            <input-field class="flex-none" placeholder=""
				                         v-model="label" tabindex="0" small  />
			            </div>
		            </div>

		            <div class="flex-none layout-column margin-b-20 details-area">
			            <div class="layout-row">
				            <div class="layout-column">
					            <span class="label">Phone number</span>
					            <span class="value">+{{ number.phone_number }}</span>
					            <span class="value margin-t-10">{{ countryName }}</span>
				            </div>
				            <div class="flex"></div>
				            <div class="layout-column">
					            <span class="label">Monthly tariff</span>
					            <span class="value">${{parseFloat(number.monthly_tariff+'').toFixed(2)}} per month</span>
					            <span v-if="vat>0" class="value vat">+${{parseFloat(vat+'').toFixed(2)}} VAT (20%)</span>
				            </div>
				            <div class="flex"></div>
			            </div>
			            <div>
				            <p>Once you place your order, we will automatically charge
					            <b>${{parseFloat(number.monthly_tariff+'').toFixed(2)}} per month</b>
					            to your default payment method under <b>Account &gt; Billing</b>.
				            </p>
			            </div>
		            </div>
	            </div>

	            <div style="min-height: 10px"></div>
            </div>

	    <div class="popup-actions layout-row">
		    <v-button label="Place order" @click="buy()" :loading="saving" />
		    <v-button label="Close" border @click="$emit('close')" />
	    </div>


    </div>

	</div>
</template>

<script>
import API from "@/api"
import Tooltip from "@/components/Tooltip.vue"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import PopupBackdrop from "@/components/base/popup-backdrop";
import BackBtn from "@/components/base/back-btn";
import VRadio from "@/components/base/v-radio";
import VSwitch from "@/components/base/v-switch";
import countries from "@/helpers/countries"; // import syntax highlighting styles

export default {
	name: "buy-number-popup",
	mixins: [API],
	components: {
		VSwitch,
		VRadio,
		BackBtn,
		PopupBackdrop,
		SelectField,
		InputField,
		VButton,
		Tooltip,
		Loading
	},
	props:{
		level: {
			type: Number,
			default: 0,
		},
		funnelId: {
			type: Number,
			default: 0,
		},
		number:{}
	},
	data() {
		return {
			label:'',
			saving: false,
			countries: [
				{id:'US', text:'United States of America'},
				{id:'GB', text:'United Kingdom'},
				{id:'CA', text:'Canada'},
				{id:'AU', text:'Australia'},
				{id:'MX', text:'Mexico'},
				{id:'PT', text:'Portugal'},
				{id:'HU', text:'Hungary'},
				{id:'NL', text:'Netherlands'},
				{id:'RO', text:'Romania'},
				{id:'CZ', text:'Czech Republic'},
				{id:'ID', text:'Indonesia'},
				{id:'SK', text:'Slovakia'},
				{id:'SE', text:'Sweden'},
				{id:'DK', text:'Denmark'},
			],

		}
	},
	computed:{
		countryName() {
			let c = this.countries.find(x=>x.id===this.number.country)
			return c ? c.text : '...';
		},
		vat(){
			if (this.$store.state.userInfo.country!=="GB") return 0;
			return 20/100 * this.number.monthly_tariff;
		}
	},
	methods: {
		closePopup() {
			this.$emit('close')
		},
		//API
		async buy() {
			try {
				this.saving = true;

				let n = await this.api.sms.buyNumber({
					label: this.label || ('+'+this.number.phone_number),
					number: this.number.phone_number,
					country: this.number.country,
				});
				if (n.error) {
					this.$error(n, "Something went wrong! Try again later or contact support.")
					return
				}
				this.$emit('done', n)
			} catch (e) {
				this.$error(e);
			} finally {
				this.saving = false;
			}
		},
	},
	created() {

	},
}
</script>
<style lang="scss" scoped>
.buy-number-popup {
	padding: 0;
	.details-area {
		border: 1px solid $light-grey;
		background: $light-silver;
		margin-bottom: 20px;
		margin-top: 10px;
		border-radius: 3px;
		position: relative;
		padding: 15px 25px;
		.label {
			color: $dark-grey;
			font-size: 14px;
		}
		.value {
			margin-top: 6px;
			font-weight: 500;
			color: $darker-grey;
			font-size: 16px;
			&.vat {
				font-size: 14px;
				opacity: 0.9;
				margin-top: 10px;
			}
		}
		p {
			margin-top: 20px;
			line-height: 1.5;
		}
	}
	.popup-actions {
		padding: 10px 30px;
		border-top: 1px solid $light-grey;
		.button {
			margin-right: 25px;
		}
	}

	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.order-status-row {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	font-size: 13px;
	align-items: center;
	color: #26252e;
	.label {
		font-weight: bold;
		margin-right: 10px;
	}
	.value {
		display: flex;
		flex-direction: row;
		margin-right: 20px;
		margin-left: 5px;
	}
}
.popup_title {
	font-size: 20px;
}
</style>
